
import React from 'react';

export default function Input({ label, name, value, onChange, type, ...optional }) {
    const inputType = type && /tel|email|text/i.test(type) ? type : 'text';

    return (
        <>
            {label ? <label htmlFor={name}>{label}</label> : ''}
            <input id={name} name={name} onChange={e => onChange(e.target.value)} value={value} type={inputType} {...optional} />
        </>
    );
}